import { Outlet } from 'react-router';

import PageWithHeader from 'portal/src/layouts/base/PageWithHeader';

import { IPageProps } from './LayoutPreference/layoutTypes';

export default function Page(props: IPageProps): React.ReactElement {
  return (
    <PageWithHeader {...props}>
      <Outlet />
    </PageWithHeader>
  );
}
